const prefix = 'attUsage';

export const FIND_CURRENT = `${prefix}/FIND_CURRENT`;
